import React from "react";
import {TAB_NOTARY} from "../../../constants/company";
import {opportunitiesSection, services, topBanner, seo, youtubeVideo} from "../../../constants/notaries";
import FormSection from "./Components/FormSection";
import WhiteDivider from "../../Shared/WhiteDivider";
import ReviewsSection from "../../Shared/Reviews";
import WhyOpportunitiesSection from "../../Shared/WhyOpportunities";
import TopBanner from "../../Shared/TopBanner";
import FAQWrapper from "../../Shared/wrappers/FAQWrapper";
import Seo from "../../Shared/Seo";
import YouTubeVideoSection from "../../../components/Shared/YoutubeVideo";

const NotaryWrapper = () => {

  return (<React.Fragment>
    <Seo title={seo.title} description={seo.description} />
    <div className="notaries">
      <TopBanner
        title={topBanner.title}
        description={topBanner.description}
        eventAction={topBanner.eventAction}
        eventLabel={topBanner.eventLabel}
        image={topBanner.image}
        altText={topBanner.altText}
      />
      <WhyOpportunitiesSection 
        title={opportunitiesSection.title} 
        image={opportunitiesSection.image} 
        altText={opportunitiesSection.altText} 
        services={services} 
      />
      <YouTubeVideoSection 
        eventAction={youtubeVideo.eventAction} 
        eventLabel={youtubeVideo.eventLabel} 
        url={youtubeVideo.url} 
      />
      <FormSection />
      <div className="bg-white">
        <ReviewsSection />
      </div>
      <FAQWrapper initialTab={TAB_NOTARY}/>
      <WhiteDivider />
    </div>
  </React.Fragment>)
}

export default NotaryWrapper;